import { Box } from '@mui/material';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import {
  MemoStatefulAutocompleteWithText,
  MemoStatefulMultiselect,
  MemoStatefulSingleSelect,
} from 'components/dataCreationForms/withInputForm/statefulInputsWrapper';
import { inspectionGridFullWidthItemSx } from 'components/inspection/layout';
import React from 'react';
import { CompanyAddressSection } from './CompanyAddressSection';
import { CompanyFormSection } from './section';
import { dialogFormSx } from './styles';
import { CompanyFieldsPresentationalProps } from './types';

export function CompanyFieldsPresentational({
  shortLabelFieldProps,
  longLabelFieldProps,
  sitesFieldProps,
  projectInvolvementTypeFieldProps,
  taxNumberFieldProps,
  addressesFieldsProps,
  isDialog,
}: CompanyFieldsPresentationalProps): React.ReactElement {
  const sections = (
    <>
      <CompanyFormSection
        titleId={ProjectSetupTranslationKeys.basicInfoSection}
        isDialog={isDialog}
        isFirst
      >
        <Box>
          <MemoStatefulAutocompleteWithText {...shortLabelFieldProps} />
        </Box>
        {longLabelFieldProps && (
          <Box>
            <MemoStatefulAutocompleteWithText {...longLabelFieldProps} />
          </Box>
        )}
        {projectInvolvementTypeFieldProps && (
          <Box>
            <MemoStatefulSingleSelect
              {...projectInvolvementTypeFieldProps}
            />
          </Box>
        )}
        {taxNumberFieldProps && (
          <Box>
            <MemoStatefulAutocompleteWithText {...taxNumberFieldProps} />
          </Box>
        )}
        <Box sx={inspectionGridFullWidthItemSx}>
          <MemoStatefulMultiselect {...sitesFieldProps} />
        </Box>
      </CompanyFormSection>
      {addressesFieldsProps.map((addressFieldsProps) => (
        <CompanyAddressSection
          key={addressFieldsProps.titleId}
          {...addressFieldsProps}
          isDialog={isDialog}
        />
      ))}
    </>
  );

  return isDialog ? <Box sx={dialogFormSx}>{sections}</Box> : sections;
}
